//
// Autoplay Cancel Button

autoplayCancelButton = {};

autoplayCancelButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);
	InputHelpers.addAutoplayFlag(button);
	button._flags.disabledByPlatform = false;

	button.canEnable = function() {
		return (
			this._flags.autoplayStarted &&
			!this._flags.modal.active &&
			!this._flags.disabledByPlatform
		);
	};

	button.canShow = function() {
		return (this._flags.autoplayStarted);
	};

	button.onPressedCallback = function() {
		gdk.cancelAutoplay();
		
		if (button.soundName !== "") {
			button.playSound();
		}
	};

	button.setButtonState = function(data){
		if (data.buttonName === "Autoplay"){
			this._flags.disabledByPlatform = !data.enabled;
		}
	};
	
	messageBus.subscribe("platform:setButtonState", button.setButtonState.bind(button));
	
	return button;
};

autoplayCancelButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
autoplayCancelButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("autoplayCancelButton", autoplayCancelButton.create, autoplayCancelButton.initialise, autoplayCancelButton.getFilesRequired);